import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { IonButton, IonRow } from '@ionic/angular/standalone';
import { Question, QuestionItemType } from 'src/app/services/slip.service';
import { SsqwCheckboxFormComponent } from './ssqw-checkbox-form/ssqw-checkbox-form.component';
import { SsqwInputFormComponent } from './ssqw-input-form/ssqw-input-form.component';
import { SsqwLongTextFormComponent } from './ssqw-long-text-form/ssqw-long-text-form.component';
import { SsqwRadioFormComponent } from './ssqw-radio-form/ssqw-radio-form.component';
import { Status } from './status';

@Component({
  selector: 'app-ssqw-form-slide',
  templateUrl: './ssqw-form-slide.component.html',
  styleUrls: ['./ssqw-form-slide.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgClass,
    SsqwLongTextFormComponent,
    SsqwInputFormComponent,
    SsqwRadioFormComponent,
    SsqwCheckboxFormComponent,
    IonRow,
    IonButton
  ]
})
export class SsqwFormSlideComponent {
  public question: Question;
  public disableOk = false;
  public showClear = false;

  public clearEmitter = new EventEmitter<void>();

  @Input()
  public set item(value: QuestionItemType) {
    this.question = value as Question;
  }
  @Input() initialValue: any;
  @Input() questionNumber: number;
  @Output() ok = new EventEmitter<void>();
  @Output() status = new EventEmitter<Status>();
  @Output() inputClicked = new EventEmitter<HTMLElement>();

  constructor(private cdr: ChangeDetectorRef) {}

  onClear(): void {
    this.clearEmitter.next();
  }

  onStatusChange(status: Status): void {
    this.disableOk = !status.valid;
    this.showClear = !!status.value;
    this.status.emit(status);

    // Need cdr for initial case where change is not result of interaction
    this.cdr.detectChanges();
  }
}
